var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdTitleRobotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.35156,
    width: 7.78837,
    height: 9,
    rx: 3.89418,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 2.35156,
    y: 4.67969,
    width: 7.78837,
    height: 4.32,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    d: "M8.71598 2.87812C8.90438 3.95812 8.84655 4.67812 6.13631 4.67812C3.3546 4.67812 3.36993 3.77812 3.52275 2.87812C3.70623 1.79812 4.80492 1.07812 6.13631 1.07812C7.46769 1.07812 8.5276 1.79812 8.71598 2.87812Z",
    fill: "#241549"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 0.128906,
    y: 3.23828,
    width: 1.85437,
    height: 3.6,
    rx: 0.927187,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 10.5156,
    y: 3.24219,
    width: 1.85437,
    height: 3.6,
    rx: 0.927187,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdTitleRobotIcon);
export default __webpack_public_path__ + "static/media/ThirdTitleRobotIcon.14f99031a150b268c9d729295d54a40e.svg";
export { ForwardRef as ReactComponent };